export default __webpack_public_path__ + "static/media/green_insurance_logo.f71986b3.jpg";